<template>
  <div id="app">
    <el-container class="top">
      <div class="container">
        <el-header>
          <el-row>
            <el-col
              :xs="24"
              :sm="24"
              :md="6"
              :lg="6"
              :xl="6"
              class="hidden-sm-and-down logo_left"
            >
              <img src="../assets/images/logo_left.png" />
            </el-col>
            <el-col :xs="24" :sm="24" :md="11" :lg="11" :xl="11">
              <div class="grid-content bg-purple logo"></div>
            </el-col>
            <el-col
              :xs="24"
              :sm="24"
              :md="6"
              :lg="6"
              :xl="6"
              class="hidden-sm-and-down logo_right"
              style="text-align: right; float: right"
            >
              <img src="../assets/images/logo_right.png" />
            </el-col>
            <div class="clearfix"></div>
          </el-row>
        </el-header>
      </div>
    </el-container>
    <div class="index-nav nav_menu">
      <div class="index-nav-frame container clearfix">
        <!-- logo -->
        <div class="nav-small" tabindex="-1" v-if="!isgzh">
          <div class="nav-small-focus" tabindex="-1" v-if="isgzhl != 2"></div>
          <img src="../assets/images/icon.png" v-if="isgzhl != 2" id="topbtn" />
        </div>
        <div
          v-for="(item, index) in NavList"
          :key="index"
          class="index-nav-frame-line pclist"
        >
          <span @click="$router.push(item.path)">{{ item.name }}</span>
          <span v-if="item.children" class="rotator">
            <img src="../assets/images/down2.png" />
          </span>
          <div
            v-if="item.children"
            class="index-nav-frame-line-center"
            :class="'list' + index"
          >
            <div
              class="index-nav-frame-line-li"
              :class="'list' + index + '' + i"
              v-for="(val, i) in item.children"
              :key="i"
            >
              <span @click="$router.push(val.path)">{{ val.name }}</span>
            </div>
          </div>
          <div class="index-nav-frame-line-focus"></div>
        </div>
        <div class="clearfix"></div>
        <div v-if="ismnav" ref="treeWrap">
          <div
            v-for="(items, indexs) in MNavList"
            :key="10 + indexs"
            class="index-nav-frame-line mobList index-nav-frame-linem"
            @click="topath(items.path)"
          >
            <span>{{ items.name }}</span>
          </div>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Search from "./Home/Search";
export default {
  name: "CommonHearde",
  components: {
    Search,
  },
  data() {
    return {
      isycb: false,
      ismnav: false,
      isgzhl: 0,
      islang: true,
      NavList: [
        { name: "首页", path: "/" },
        {
          name: "期刊介绍",
          path: "",
          children: [
            { name: "期刊简介", path: "/FixedBody?ItemId=10" },
            { name: "所获荣誉", path: "/FixedBody?ItemId=20" },
          ],
        },
        {
          name: "编委会",
          path: "",
          children: [
            { name: "现任编委会", path: "/FixedBody?ItemId=1500" },
            { name: "编委会章程", path: "/FixedBody?ItemId=40" },
          ],
        },
        {
          name: "投稿指南",
          path: "",
          children: [
            { name: "投稿须知", path: "/FixedBody?ItemId=30" },
            { name: "文件下载", path: "/DocumentList?ColumnId=6" },
          ],
        },
        {
          name: "下载中心",
          path: "/DocumentList?ColumnId=6",
          // children: [
          //   {
          //     name: "过刊目录",
          //     path: "/dlistnum",
          //   },
          //   { name: "最新一期", path: "/OAList?IssueId=-1" },
          //   { name: "预出版", path: "/PreprintList" },
          //   {
          //     name: "高级检索",
          //     path: "/AdvancedSearch",
          //   },
          //   {
          //     name: "下载排行",
          //     path: "/DownloadlistViewlist?Key=ReadRank",
          //   },
          //   {
          //     name: "浏览排行",
          //     path: "/DownloadlistViewlist?Key=ViewRank",
          //   },
          // ],
        },
        {
          name: "科技服务",
          path: "",
          children: [
            {
              name: "学会",
              path: "/FixedBody?ItemId=21",
            },
            {
              name: "行业协会",
              path: "/FixedBody?ItemId=22",
            },
            {
              name: "标准化技术委员会",
              path: "/FixedBody?ItemId=23",
            },
            {
              name: "联盟",
              path: "/FixedBody?ItemId=24",
            },
            {
              name: "技术创新平台",
              path: "/FixedBody?ItemId=25",
            },
            {
              name: "公共检测平台",
              path: "/FixedBody?ItemId=26",
            },
          ],
        },
        { name: "期刊订阅", path: "/FixedBody?ItemId=3600" },
        { name: "联系我们", path: "/FixedBody?ItemId=50" },
      ],
      MNavList: [
        { name: "主页", path: "/" },
        { name: "期刊简介", path: "/FixedBody?ItemId=10" },
        { name: "所获荣誉", path: "/FixedBody?ItemId=20" },
        { name: "现任编委会", path: "/FixedBody?ItemId=1500" },
        { name: "编委会章程", path: "/FixedBody?ItemId=40" },
        { name: "投稿须知", path: "/FixedBody?ItemId=30" },
        { name: "文件下载", path: "/DocumentList?ColumnId=6" },
        { name: "下载中心", path: "/DocumentList?ColumnId=6" },
        { name: "学会", path: "/FixedBody?ItemId=21" },
        { name: "行业协会", path: "/FixedBody?ItemId=22" },
        { name: "标准化技术委员会", path: "/FixedBody?ItemId=23" },
        { name: "联盟", path: "/FixedBody?ItemId=24" },
        { name: "技术创新平台", path: "/FixedBody?ItemId=25" },
        { name: "公共检测平台", path: "/FixedBody?ItemId=26" },
        { name: "期刊订阅", path: "/FixedBody?ItemId=3600" },
        { name: "联系我们", path: "/FixedBody?ItemId=50" },
      ],
    };
  },
  props: ["isgzh"],
  created() {
    if (sessionStorage.getItem("SetItem")) {
      let SetItem = JSON.parse(sessionStorage.getItem("SetItem"));
      SetItem.map((item) => {
        if (item.SetItemID == 4530) {
          item.Item_Value == "是" ? (this.isycb = true) : (this.isycb = false);
        }
        if (item.SetItemID == 2900) {
          item.Item_Value == "是"
            ? (this.islang = true)
            : (this.islang = false);
        }
      });
    }
  },
  mounted() {
    let _this = this;
    if (this.$route.query) {
      this.isgzhl = this.$route.query.isgzh;
    }
    document.addEventListener("mouseup", (e) => {
      let tree = this.$refs.treeWrap;
      if (e.target.id == "topbtn") {
        this.ismnav = !this.ismnav;
      }
      if (tree) {
        if (!tree.contains(e.target)) {
          this.ismnav = false;
        }
      }
    });
  },
  methods: {
    topath(url) {
      this.$router.push(url);
      this.ismnav = false;
    },
  },
};
</script>

<style scoped>
.index-nav-frame-linem a {
  width: 100%;
  display: inline-block;
}
@media (max-width: 768px) {
  .language {
    position: absolute;
    top: 5px;
    right: 10px;
  }
  .quick {
    margin-top: 20px !important;
  }
}
</style>
